var styleDataHash = '9786c469';  
export const injectCss = (() => {
  var css = `.jQDux{display:flex;min-width:0;pointer-events:none;transition:width .2s ease-out,min-width .2s ease-out;width:0}.jQDux.Oevg4{min-width:42px;transition:width .2s ease-in,min-width .2s ease-in;width:42px}.jQDux.Oevg4 .McsVY{opacity:1;pointer-events:all;position:relative;transition:opacity .1s ease-out;z-index:1}.jQDux.Oevg4 .qEpdP{left:0;position:absolute;top:0;transition:opacity .1s ease-out}.jQDux.reDcr{min-width:84px;transition:width .1s ease-in,min-width .1s ease-in;width:84px}.jQDux.reDcr .qEpdP{opacity:1;pointer-events:all;position:relative;transition:opacity .1s ease-in .1s;z-index:1}.jQDux.reDcr .McsVY{left:0;position:absolute;top:0}.jQDux .qEpdP{transition:opacity .1s ease-out}.jQDux .McsVY,.jQDux .qEpdP{opacity:0;pointer-events:none;z-index:0}.jQDux .McsVY{left:0;position:absolute;top:0;transition:opacity 0s}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "buttonWrapper": "jQDux",
  "visibleSubmit": "Oevg4",
  "submitButton": "McsVY",
  "cancelButton": "qEpdP",
  "visibleCancel": "reDcr"
};